export const ASON = "ASON";
export const BETWEEN = "BETWEEN";
export const SINGLESOA = "SINGLESSOA";
export const MULTISOA = "MULTISOA";
export const SUMMARY = "SUMMARY";
export const DETAILED = "DETAILED";
export const CURRENTFINANCIALYEAR = "CURRENTFINANCIALYEAR";
export const PREVIOUSFINANCIALYEAR = "PREVIOUSFINANCIALYEAR";
export const SPECIFICPERIOD = "SPECIFICPERIOD";

